/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest,
  TelegramAuthPhoneControllerSendCodeByPhoneMutationResponse,
  TelegramAuthPhoneControllerSendCodeByPhone400,
  TelegramAuthPhoneControllerSendCodeByPhone401,
  TelegramAuthPhoneControllerSendCodeByPhone403,
  TelegramAuthPhoneControllerSendCodeByPhone429,
} from '../types/TelegramAuthPhoneControllerSendCodeByPhone.ts';

function getTelegramAuthPhoneSendCodeByPhoneUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/phone/send-code` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/phone/send-code}
 */
export async function telegramAuthPhoneSendCodeByPhone(
  data: TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest,
  config: Partial<RequestConfig<TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthPhoneControllerSendCodeByPhoneMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthPhoneControllerSendCodeByPhone400
      | TelegramAuthPhoneControllerSendCodeByPhone401
      | TelegramAuthPhoneControllerSendCodeByPhone403
      | TelegramAuthPhoneControllerSendCodeByPhone429
    >,
    TelegramAuthPhoneControllerSendCodeByPhoneMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthPhoneSendCodeByPhoneUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
